import { createUseStyles } from 'react-jss';

const styles = {
  toolbar: {
    background: '#F7F7F7',
    border: '1px solid #D9D9D9',
    boxSizing: 'border-box',
    height: '2.5rem'
  },
  toolbarTitle: {
    paddingLeft: '0.7rem'
  },
  div: {
    width: '100%'
  },
  metadata: {
    '& span': {
      marginRight: '0.7rem'
    }
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'Attachments'
});
